import { render, staticRenderFns } from "./VehicleReestrRegion.vue?vue&type=template&id=a61cf1d6&"
import script from "./VehicleReestrRegion.vue?vue&type=script&lang=js&"
export * from "./VehicleReestrRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports